import { useSelector } from "react-redux";

export const useHardCode = () => {
  const otherSettingsState = useSelector((state) => state.otherSettings);

  let shopifyShopObject;
  try {
      shopifyShopObject =
          "viveksaarastore.myshopify.com"; //Replace the right side after || with your store when testing in local
  } catch (error) {
      console.error("Error fetching Shopify shop object:", error.message);
      if (window.location.ancestorOrigins && window.location.ancestorOrigins.length > 0) {
          shopifyShopObject = window.location.ancestorOrigins[0].replace(/^https?:\/\//, '');
      } else {
          console.error("ancestorOrigins is not available.");
      }
  }
  const SHOPIFY_SHOP_OBJECT = shopifyShopObject

  const CURRENT_STORE_NAME = {
    steve_maiden: "stevemadden-za.myshopify.com",
    pure_female: "purefemale.myshopify.com",
    immaculate_vegan: "immaculatevegan.myshopify.com",
    arrak: "hiking-and-sport-training-wear.myshopify.com",
    unfurl: "unfurl-clothing.myshopify.com"
  };

  const PURE_FEMALE_TRANSLATION = {
    exchange_text: {
      color: "Färg",
      size: "Storlek",
      variant_subtitle: "Välj storlek som du vill byta till",
      no_variant: "Inga andra varianter finns",
      out_of_stock: "Slut i lager",
      exchange_value: "Bytesvärde",
    },

    common_text: {
      default_description: `Vi har tagit emot din bytesbegäran RAN#${otherSettingsState.ran}.Så snart vi har tagit emot din retur så skickar vi ditt byte`,
      final_submission: `Vi har tagit emot din retur/bytesbegäran ${otherSettingsState.ran}. Du kommer inom kort att få en QR-kod via e-post. Ta med denna till ditt närmsta Postombud så skriver de ut returetiketten åt dig. När ditt paket har kommit till vårt lager så får du en bekräftelse via e-post från oss.`,
      final_submission_p2: `Vi har tagit emot din bytesbegäran ${otherSettingsState.ran}.  Så snart vi har tagit emot din retur så kommer vi att skicka ditt byte.`,
    },
    error_page: {
      page_not_found: `sidan hittades inte`,
      instead_found_eco_friendly_and_painless_returns:
        "hittade istället miljövänliga och smärtfria returer",
      home: "hem",
      ooops_something_went_wrong_but_did_we_just_reduce_a_return:
        "oops_något_gick_fel_men_kanske_minskade_vi_antalet_returer",
      refresh: "uppdatera",
    },
    all_item_navigate: {
      exchange_with_other_items: "byte till annan vara",
      desc: "Du kommer att omdirigeras till shoppen där du kan välja produkten som du vill byta till. Eventuell ytterligare betalning som krävs för den nya produkten kan du genomföra när du har klickat på kassan.",
      back: "tillbaka",
      proceed: "fortsätt",
    },
    incentive_certificate: {
      heading: "Kämpa för klimatet",
      desc: "Jag har valt att behålla varan och undvika koldioxidutsläppen i samband med returfrakt. Det är dags att vi försöker minska avkastningen och kämpa för klimatet",
      brand: "EcoReturns",
      share: "Dela och uppmuntra andra",
      button: "Skapar ditt certifikat",
    },
    exchange_option_other_items: {
      price: "pris",
      view_details: "visa detaljer",
    },
    exchange_submitted: {
      coupon_code_info: "rabattkod info",
      desc: "Använd nedanstående kupong om den utbytta rabatten inte tillämpas",
    },
    refund_options: {
      get_extra: "få extra",
      store_credit: "tillgodo",
      minus_any_charges: "minus eventuella avgifter",
    },
    form: {
      powered_by: "Drivs av",
    },
    return_options: {
      exchange_with_items_upto: "byte till andra produkter upp till",
      higher_than_the_original_item: "högre än ursprungsvaran",
      get_additional_store_credit_of: "få extra tillgodo",
    },
    upload_image: {
      error_message_size: "Filen bör vara mindre än 10 MB",
      error_message_type: "Endast bild är tillåten",
      uploading_your_files: "ladda upp fil",
      show_add_more: "visa lägg till mer",
    },

    review: {
      review_return: "Granska retur",
      summary: `Sammanfattning`,
      refund_method: `Återbetalning till:`,
      original_payment_method: `Betalsätt som användes vid köp`,
      store_credits: `Tillgodo`,
      contact_information: `Kontaktinformation`,
      edit: `Redigera`,
      from_address: `Från`,
      save: "Spara",
      cancel: "Annullera",
    },
    return_exchange_more: "Returnera/byta mer",
  };

  const STEVE_MAIDEN = {
    common_text: {
      return_more: "Return more",
    },
  };

  const IMMACULATE_VEGAN = {
    disclaimer: {
      heading: `Disclaimer`,
      content: `By submitting the return/exchange, I confirm that the item(s) I am sending is completely unworn, unused and in brand new condition, with hygiene stickers attached (if applicable). I understand that if the brand does not receive the item in a resellable condition, the return may be rejected.`,
    },
  };

  const ARRKA = {
    return_exchange_final_submission: {
      content: `We have received your return request, and your RMA number is ${otherSettingsState.ran}. Please check your email for your order. There, you will find a link where you can purchase a discounted label for the return of your product. Please be sure to send your product back to your return within 14 days, as your label will automatically cancel.`,
    },
  };

  return {
    SHOPIFY_SHOP_OBJECT,
    CURRENT_STORE_NAME,
    PURE_FEMALE_TRANSLATION,
    STEVE_MAIDEN,
    IMMACULATE_VEGAN,
  };
};
